module.exports = __webpack_public_path__ + "static/media/icon-bell.08a35615.svg";